import { render } from "./AskDoubt.vue?vue&type=template&id=47e616aa&scoped=true"
import script from "./AskDoubt.vue?vue&type=script&lang=js"
export * from "./AskDoubt.vue?vue&type=script&lang=js"

import "./AskDoubt.vue?vue&type=style&index=0&id=47e616aa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e616aa"]])

export default __exports__